import React from 'react';
import { t } from '../services/translation';

const SuccessPage: React.FC = () => {
  return (
    <div className="jw-success jw-step-enter" id="jw-reg-step-success">
      <div className="jw-success-icon" aria-hidden="true">✓</div>
      <h2>{t('Sikeres regisztráció!')}</h2>
      <p>
        {t('Köszönjük a regisztrációt! E-mailben elküldtük az aktiváló hivatkozást. Kérjük, ellenőrizd a fiókodat és kattints az aktiváló linkre a belépéshez.')}
      </p>
      <p style={{ marginTop: 14, fontSize: 13, color: 'var(--color-text-muted)' }}>
        {t('Az aktiválás után a megadott e-mail címeddel és jelszavaddal tudsz majd bejelentkezni.')}
      </p>
    </div>
  );
};

export default SuccessPage;
